export const TWO_FA_REQUIRED = "TwoFARequired";

export const SET_UP_2FA_TITLE = "2-Factor Authentication";
export const SET_UP_2FA_MESSAGE1 =
  "A one-time verification Code will be sent to your mobile phone number via ";
export const SET_UP_2FA_MESSAGE2 =
  "Please provide a valid mobile phone number and click on Send Verification Code.";
export const SEND_VERIFICATION_CODE = "Send Verification Code";

export const VERIFY_2FA_MESSAGE1 =
  "Please provide a verification code received from ";

export const VERIFY_2FA_MESSAGE2 = "Then click on Verify Code button.";

export const EMAIL_TOKEN_ERROR_MESSAGE = "Email verification link had expired, please relogin.";
export const EMAIL_TOKEN_ERROR_KEY = "Invalid token";

export const RESEND_CODE = "Resend";
export const VERIFY_CODE = "Verify Code";
export const BACK_TO_LOGIN = "Back to Login";

export const UPDATE_2FA_MOBILE_NUMBER = "Update 2FA Phone Number";

export const SEND_VERIFICATION_EMAIL_MESSAGE1 =
  "<p><strong>A verification email has been sent to your inbox ending with </strong></p>";
export const SEND_VERIFICATION_EMAIL_MESSAGE2 =
  "<p><strong>Please check your email to provide a valid mobile phone number to set up 2-Factor Authentication.</strong></p>";

export const INVALID_EMAIL_MESSAGE =
  "<p><strong>Invalid email address.</strong></p><p><strong>Please contact PPCXA Contact Centre for assistance.</strong></p>";

export const ACCOUNT_LOCKED_MESSAGE =
  "<p><strong>Your account is temporarily locked for 60 minutes as you have entered an invalid code more than 5 times.</strong></p><p><strong>Please try again later, or contact PPCXA Contact Centre for assistance.</strong></p>";

export const TWOFA_LOCKED_KEY = "TWOFA_LOCKED";
export const TWOFA_BLOCKED_RESEND_KEY = "TWOFA_BLOCKED_RESEND";

export const VERIFICATION_CODE_IS_REQUIRED = "Verification Code is required";

export const TRY_OTHER_TWO_FA_MODE = "Didn't receive your verification code?";



// WEBPACK FOOTER //
// ./components/twoFA/constants.js